function pasteAsAr() {
    const {
        commands: {pasteTreeAsAr},
        selectedNodes,
    } = this

    pasteTreeAsAr([...selectedNodes])
}

export default {
    'Ctrl+Alt+V': pasteAsAr,
}
